// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.payments.RentalManagerUserPropertyPaymentWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { ListingAlias, UserPaymentDefaultPaymentMethodResponseWebDto } from '../..';

interface GetDefaultPaymentMethodParams {
  listingAlias: ListingAlias;
}

export const RentalManagerUserPropertyPaymentWebApiHandler_getDefaultPaymentMethod_Path =
  '/api/web/v1/users/properties/payments/getDefaultPaymentMethod';

/**
 * Get user default payment method
 */
export const RentalManagerUserPropertyPaymentWebApiHandler_getDefaultPaymentMethod = (
  getParams: GetDefaultPaymentMethodParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<GetDefaultPaymentMethodParams, never, UserPaymentDefaultPaymentMethodResponseWebDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyPaymentWebApiHandler_getDefaultPaymentMethod_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};
